<script>
  import { onMount } from "svelte";
  export let saving = false;
  let autoSavingImgSrc = undefined;
  onMount(() => {
    autoSavingImgSrc = document.getElementById("imgLoading").src;
  });
</script>

{#if saving}
  <div class="auto-saving-loading">
    <img src={autoSavingImgSrc} alt="Auto Saving" />
    <span class="ms-2">Auto saving ...</span>
  </div>
{/if}
